import React, { Component } from "react";

const tableStyle = {
  table: {
    width: "100%",
    marginTop: 50,
    textAlign: "left",
  },
  tr: {
    height: 45,
  },
};

class JaShoppingPolicy extends Component {
  render() {
    return (
      <div className="shipping-policy-page">
        <div className="shipping-policy-container" style={styles.container}>
          <p className="shipping-policy-title" style={styles.title}>特定商取引法に基づく表記</p>

          <table className="shipping-policy-table" style={tableStyle.table}>
            <tr style={tableStyle.tr}>
              <th>会社名</th>
              <th>グラブワークス株式会社（Gloveworks 株式会社）</th>
            </tr>
            <tr style={tableStyle.tr}>
              <th>代表者</th>
              <th>キム・ドンウク</th>
            </tr>
            <tr style={tableStyle.tr}>
              <td>所在地</td>
              <td>
              韓国ソウル特別市龍山区（ヨンサン グ）会楠路13ギル52-11
                <br />
                〒04342
              </td>
            </tr>
            <tr style={tableStyle.tr}>
              <th>電話番号</th>
              <th>+82 10 6830 2629（営業 12:00～16:00／土日・祝日除く）</th>
            </tr>
            <tr style={tableStyle.tr}>
              <th>サイトURL</th>
              <th>https://jp.gloveworks.net</th>
            </tr>
            <tr style={tableStyle.tr}>
              <td>お問い合わせ</td>
              <td>
                {/* OUTLIER - 20240122 - 6번 */}
                {/* <u
                  style={styles.email}
                  tabIndex="-1"
                  role="button"
                  onClick={() =>
                    (document.location.href =
                      "mailto:Gloveworks.jp@gloveworks.net")
                  }
                >
                  Gloveworks.jp@gloveworks.net
                </u> */}
                <u
                  style={styles.email}
                  tabIndex="-1"
                  role="button"
                  onClick={() =>
                    (document.location.href = "mailto:donald@gloveworks.net")
                  }
                >
                  donald@gloveworks.net
                </u>
                <br />
              </td>
            </tr>
            <tr style={tableStyle.tr}>
              <td>商品価格</td>
              <td>各商品ページをご参照ください。</td>
            </tr>
            <tr style={tableStyle.tr}>
              <td>商品代金以外に必要な料金</td>
              <td>
              消費税、配送料、輸入関税、決済手数料 (銀行振込手数料等)
              </td>
            </tr>
            <tr style={tableStyle.tr}>
              <td>お支払い方法</td>
              <td>
                – PayPal（クレジットカード／デビットカード／銀行振込）
                <br />
                – Paymentwall（コンビニ払い対応）
                <br />
                – 銀行振込（別途ご案内）
              </td>
            </tr>
            <br />
            <tr style={tableStyle.tr}>
              <td>商品引き渡し時期</td>
              <td>下記＜配送・発送＞項をご参照ください。</td>
            </tr>
            <tr style={tableStyle.tr}>
              <td>返品可否・条件</td>
              <td>下記＜返品・交換・返金＞項をご参照ください。</td>
            </tr>
          </table>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>配送状況の照会</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          発送時には、追跡番号および配送業者情報を記載したメールをお送りします。
またサイトの「注文状況」より、ログインのうえご確認いただけます。
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>配送方法</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          DHL、EMS、USPS、SF Express（中国内）など、提携配送業者にて配送いたします。
当社の生産拠点・物流倉庫は中国および韓国にございます。

            <br />
            <br />
            配送会社の規定により、私書箱（PO Box）や農村部のルート住所への配送は不可です。
正確な配送のため、必ず実際に受け取れる住所をご登録ください。
登録情報の誤りや配送業者の都合によるトラブルは責任を負いかねます。

            <br />
            <br />
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>配送料金</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          配送先・商品カテゴリにより、以下の通り設定されています。
            <br />
            <br />
            <b style={styles.descTitle}>
              1.
              1.	グラブ（カスタム／既製／トレーナー／パンケーキ／プロワン）およびグラブ叩き台
            </b>
            <br />
            {/* OUTLIER - 20240122 - 4번 */}
            {/* &nbsp;&nbsp;&nbsp;&nbsp; アメリカ＆カナダ　3000円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; 米国・カナダ：6,000 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 中南米：7,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; ヨーロッパ　 3500円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; ヨーロッパ：5,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; オーストラリア＆ニュージーランド　 3500円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; オーストラリア／ニュージーランド：5,000 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; 東南アジア(日本、大韓民国)　 2500円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; 東南アジア（日本・韓国）：3,800 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 中国／台湾／香港：1,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; 東南アジア＆南アジア　 5500円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; その他東南・南アジア：5,700 円
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>2. マレット（グラブマレット）</b>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 米国・カナダ：3,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; 中南米　4500円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; 中南米：5,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; ヨーロッパ　 2300円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; ヨーロッパ：2,500 円
            <br />
            {/* &nbsp;&nbsp;&nbsp;&nbsp; オーストラリア＆ニュージーランド　2300円 */}
            &nbsp;&nbsp;&nbsp;&nbsp; オーストラリア／ニュージーランド：4,000 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 東南アジア（日本・韓国）：1,700 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 中国／台湾／香港：1,300 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; その他東南・南アジア：3,500 円
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>3. キャップ＆ペナント</b>
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 米国・カナダ：3,000 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 中南米：3,500 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; ヨーロッパ：2,500 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; オーストラリア／ニュージーランド：4,000 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 東南アジア（日本・韓国）：1,300 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; 中国／台湾／香港：1,000 円
            <br />
            &nbsp;&nbsp;&nbsp;&nbsp; その他東南・南アジア：2,500 円
            <br />
            <br />
            <br />
            <b style={styles.descTitle}>4. グラブオイル</b>
            <br />
            他商品と併せての注文に限り承ります（単品購入不可）。
            <br />
            配送料は無料です。大量購入希望の場合は、
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:contact@gloveworks.net")
              }
            >
              contact@gloveowork.net
            </u>{" "}
            までご連絡ください。
            <br />
            <br />
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>配送料の割引</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          カスタムまたは既製グラブ 4 点以上の同時注文で、配送料を 20％割引にいたします。
          <br />
          (同一カテゴリ内の購入時に適用／自動割引）
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>関税について</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          当社製品は中国より生産・発送され、輸入通関時に関税が発生します。
            <br />
            日本・韓国・米国・台湾宛は、送料に関税を含んでおります（2025年7月時点）。
            <br />
            ただしカナダ等一部地域では含まれない場合があり、その際は配送会社より案内後、お客様にて直接お支払いいただきます。
            <br />
            関税や通関書類の取得については、配送案内メールに記載の配送会社へお問い合わせください。
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>[返品・交換・返金ポリシー]</p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>注文キャンセル・返金</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          カスタムグラブは、注文後 48 時間以内であればキャンセルおよび返金が可能です。
          <br />
          48 時間を過ぎると製作開始となり、以降のキャンセル・返金は不可となります。
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>返品・交換</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          カスタムオーダー品は、お客様ごとに製作するため お客様都合による返品・交換は不可です。
          <br />
          ただし、当社責任による不良・誤配送があった場合は、製品受領日から 2 週間以内に 
          {" "}<u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>{" "}
          までご連絡ください。
          <br />
          状況確認のうえ、交換または返金対応いたします。
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>製品保証</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
          製品受領日より <strong style={{fontWeight: "bold"}}>6 ヵ月以内</strong>の品質不良については保証対象です。
          <br />
          問題があった場合は {" "}
            <u
              style={styles.email}
              tabIndex="-1"
              role="button"
              onClick={() =>
                (document.location.href = "mailto:donald@gloveworks.net")
              }
            >
              donald@gloveworks.net
            </u>
            までご連絡ください。迅速に対応いたします。
          </p>

          <p className="shipping-policy-subtitle" style={styles.subTitle(64)}>商品の引渡し時期</p>
          <p className="shipping-policy-description" style={styles.description(10)}>
            既製品（アパレル・アクセサリー等）：決済完了後、3～14 営業日以内に発送
            <br />
            カスタムグラブ：決済完了および詳細内容確認後、平均 4～16 週間で発送（オプション数や繁忙期によってはさらにお時間をいただく場合がございます）
          </p>
        </div>
      </div>
    );
  }
}

const styles = {
  container: {
    width: '100%',
    maxWidth: 996,
    margin: "auto",
    marginBottom: 64,
    padding: '0 20px',
    boxSizing: 'border-box',
  },
  title: {
    fontFamily: "Roboto Condensed",
    fontSize: 24,
    lineHeight: 1.33,
    letterSpacing: 0.2,
    color: "#142935",
    fontWeight: "bold",
    textAlign: "center",
    marginTop: 50,
  },
  subTitle: (marginTop) => ({
    fontSize: 18,
    fontWeight: "bold",
    lineHeight: 1.33,
    color: "#000",
    marginTop,
  }),
  description: (marginTop) => ({
    whiteSpace: "pre-line",
    fontSize: 14,
    marginTop,
    lineHeight: 1.57,
    color: "#142935",
  }),
  descTitle: {
    fontWeight: "bold",
  },
  email: {
    color: "#007dff",
    cursor: "pointer",
    outline: "none",
  },
};

export default JaShoppingPolicy;
